export const RASA_AUTH_TOKEN: string = 'RASA_AUTH_TOKEN'
export const TWO_FACTOR_AUTH_TOKEN: string = 'TWO_FACTOR_AUTH_TOKEN'
export const VALID_TOKEN = 'VALID_TOKEN'
export const CREATE_TOKEN = 'CREATE_TOKEN'
export const INVALID_TOKEN = 'INVALID_TOKEN'
export const LOGGED_OUT = 'LOGGED_OUT'

// This app is the dashboard. Onboarding-api tags every forced redirect with
// the app it points at (`redirectTarget`), so one aimed at us means "stay
// put", not "navigate". Hostname comparison can't answer this on its own —
// the dashboard is reachable at more than one host.
export const THIS_APP_REDIRECT_TARGET: string = 'dashboard'
